import { useEffect } from 'react';

import { calculateDepth } from './calculateDepth';

function isSameOrigin(targetWindow: Window | null, currentWindow: Window | null = window) {
	let isSameOrigin;
	try {
		isSameOrigin = targetWindow?.location.origin === currentWindow?.location.origin;
	} catch (e) {
		// catch the DOM exception, mark the resolution to "false"
		isSameOrigin = false;
	}
	return isSameOrigin;
}

type WindowWithHostOffsetOverride = Window & {
	getHostOffsetFunctionOverride?: (hostWindow: Window) => number;
};

const attachHostOffsetOverride = (window: Window) => {
	const topWindow = window.top as WindowWithHostOffsetOverride | null;
	if (topWindow) {
		if (isSameOrigin(topWindow)) {
			const containerDepth = calculateDepth(window);
			topWindow.getHostOffsetFunctionOverride = (hostWindow: Window) =>
				calculateDepth(hostWindow, containerDepth + 1);
		}
	}
};

const detachHostOffsetOverride = () => {
	const topWindow = window.top as WindowWithHostOffsetOverride | null;
	if (topWindow) {
		if (isSameOrigin(topWindow)) {
			delete topWindow.getHostOffsetFunctionOverride;
		}
	}
};

export function useHostOffsetOverride(): void {
	useEffect(() => {
		attachHostOffsetOverride(window);
		return () => {
			detachHostOffsetOverride();
		};
	}, []);
}
